import React from 'react';
import PropTypes from 'prop-types';
import StarIcon from '@chronos/components/Icons/StarIcon';
import OnlineIndicator from '@chronos/components/OnlineIndicator/OnlineIndicator';
import MenuLink from './MenuLink';
import * as S from './styled';

const BoardMenuItem = ({ board, onClick }) => (
  <S.MenuItem key={board.id}>
    <MenuLink
      to={`/${board.id}`}
      onClick={(ev) => {
        ev.preventDefault();
        onClick(board.id);
      }}
    >
      <S.BoardName>
        {board.name}
        {board.hasLiveWorklogs && (
          <OnlineIndicator
            status="online"
            size="large"
            pulse
          />
        )}
      </S.BoardName>
      <S.Icons>{board.starred && <StarIcon />}</S.Icons>
    </MenuLink>
  </S.MenuItem>
);

BoardMenuItem.propTypes = {
  board: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    starred: PropTypes.bool,
    hasLiveWorklogs: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BoardMenuItem;
